import React from "react";

interface SubmitButtonProps {
    loading: boolean;
    isEditMode: boolean;
    disabled?: boolean;
    isViewMode: boolean;
    variant?: 'page';
    className?: string;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({
    loading,
    isEditMode,
    isViewMode,
    disabled = false,
    variant,
    className = ''
}) => {
    const isPageVariant = variant === 'page';
    const baseClass = isPageVariant
        ? 'px-8 py-[13px] bg-[#E761A0] text-white rounded-[14px] hover:bg-transparent hover:border-2 transition-all duration-200 font-semibold uppercase tracking-wide disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2'
        : 'flex-1 px-4 py-3 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-lg hover:from-green-700 hover:to-emerald-700 transition-all duration-200 shadow-lg shadow-green-600/20 hover:shadow-green-600/30 font-semibold disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:shadow-none flex items-center justify-center gap-2';
    const buttonClass = [baseClass, className].filter(Boolean).join(' ');
    const label = isPageVariant
        ? (loading ? (isEditMode ? "Updating..." : "Creating...") : (isEditMode ? "UPDATE" : "SUBMIT"))
        : (loading ? (isEditMode ? "Updating..." : "Creating...") : (isEditMode ? "Update Project" : "Create Project"));

    return (
        <div className="flex pt-2">
            <button
                type="submit"
                disabled={loading || disabled || isViewMode}
                className={buttonClass.trim()}
            >
                {loading && (
                    <div className="w-5 h-5 border-2 border-t-transparent border-white rounded-full animate-spin"></div>
                )}
                <span>{label}</span>
            </button>
        </div>
    );
};

export default SubmitButton;





